/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { useTranslation } from "react-i18next";
import logo_iso from "../../assets/images/compliance/iso-ias-new.png";
import logo_gopaperless from "../../assets/images/logos/paperless/paperless-logo-white-2.jpg";
import icon_telephone from "../../assets/images/pictures/icon/telephone.svg";
import icon_landline from "../../assets/images/pictures/icon/landline.svg";
import icon_mail from "../../assets/images/pictures/icon/mail.svg";
import icon_city from "../../assets/images/pictures/icon/city.svg";
import { useSelector } from "react-redux";
import gopaperless_pdf from "../../doc/compliance/Certificate_set_Mobile ID_20241209.pdf";
import google_play_en from "../../assets/images/logos/android-ios/google-play-en.png";
import google_play_vi from "../../assets/images/logos/android-ios/google-play-vi.png";
import app_store_en from "../../assets/images/logos/android-ios/app-store-en.png";
import app_store_vi from "../../assets/images/logos/android-ios/app-store-vi.svg";
import "./custom_footer.css";
import { Link } from "react-router-dom";
import { selectLanguage } from "../../redux/language/selector";

const Footer = () => {
    const { t, i18n } = useTranslation();
   const language = useSelector(selectLanguage);
  return (
    <div>
      <footer>
        <div className="footer-container">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-4 footer-banners pl-md-0 ">
                <p className="footer-banners__logo_1">
                  <img
                    src={logo_gopaperless}
                    data-no-retina=""
                    alt="GoPaperless"
                  />
                </p>
                <p className="text-white copyrights">
                  {t("home-page.home-footer.footer-list.mobile-id")}
                </p>
                <p className="text-white copyrights">
                  <img src={icon_city} alt="" />{" "}
                  {t("home-page.home-footer.footer-list.address")}
                </p>
                <div className="justify-between-md">
                  <p className="text-white copyrights">
                    <img src={icon_landline} alt="" /> 1900 6884
                  </p>
                  <p className="text-white copyrights">
                    <img src={icon_telephone} alt="" /> +84 28 3622 2982
                  </p>
                </div>
                <p className="text-white copyrights pb-5">
                  <img src={icon_mail} alt="" />
                  <a href="mailto:info@mobile-id.vn" className="ml-5">
                    info@mobile-id.vn
                  </a>
                </p>
                <ul>
                  <li className="footer-logo">
                    <a
                      // href="/uploads/Certificate-ISO-2700-2022-Mobile-ID-20241209"
                      href="https://mobile-id.vn/uploads/Mobile-ID-ISO-27001-2022-Certification"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={logo_iso}
                        alt="Qualified Trust Service Provider for e-signatures and e-seals validation"
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-md-9 col-sm-8 ">
                <ul className="row list list-unstyled menu-list mb-0 pl-32">
                  <li className="col-md-3 col-sm-3 col-xs-6">
                    <ul className="list list-unstyled">
                      <li className="list-heading">
                        {t("home-page.home-footer.footer-list.portal")}
                      </li>
                      <li>
                        <Link to="/features">
                          {t("home-page.home-footer.footer-list.features")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/features-for-teams">
                          {t(
                            "home-page.home-footer.footer-list.features-for-teams"
                          )}
                        </Link>
                      </li>
                      <li>
                        <Link to="/deployment">
                          {t("home-page.home-footer.footer-list.deployment")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/compliance">
                          {t("home-page.home-footer.footer-list.compliance")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/case-studies">
                          {t("home-page.home-footer.footer-list.use-cases")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/all-features">
                          {t("home-page.home-footer.footer-list.all-features")}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="col-md-3 col-sm-3 col-xs-6 min-h-220">
                    <ul className="list list-unstyled">
                      <li className="list-heading">
                        {t("home-page.home-footer.footer-list.company")}
                      </li>
                      <li>
                        <Link to="/about-us">
                          {t("home-page.home-footer.footer-list.about-us")}
                        </Link>
                      </li>
                      {/* <li><Link to="javascript:;">{t('home-page.home-footer.footer-list.careers')}</Link></li> */}

                      <li>
                        <Link to="/contacts">
                          {t("home-page.home-footer.footer-list.contacts")}
                        </Link>
                      </li>
                       <li>
                        <Link
                          to= {language === "vi" ? "/uploads/GoPaperless-DieuKhoanVaDieuKienSuDung" :"/uploads/GoPaperless-TermService"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("home-page.home-footer.footer-list.term_service")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={language === "vi"? "/uploads/GoPaperless-ChinhSachBaoMatThongTin":"/uploads/GoPaperless-InformationSecurityPolicy"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("home-page.home-footer.footer-list.information")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={language === "vi" ? "/uploads/GoPaperless-ChinhSachThuThapVaXuLyDuLieuCaNhan" :"/uploads/GoPaperless-PersonalDataCollectionProccessPolicy"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("home-page.home-footer.footer-list.personal")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={language === "vi" ? "/uploads/GoPaperless-CanhBaoRuiRoQuyenThuHoiChiaSeThongTinVNeID" : "/uploads/GoPaperless-WarningDataSharingFromVNeID"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("home-page.home-footer.footer-list.warning")}
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="col-md-3 col-sm-3 col-xs-6">
                    <ul className="list list-unstyled">
                      <li className="list-heading">
                        {t("home-page.home-footer.footer-list.resources")}
                      </li>
                      {/* <li>
                        <Link to="javascript:;">
                          {t("home-page.home-footer.footer-list.blog")}
                        </Link>
                      </li> */}
                      {/* <li><Link to="javascript:;">{t('home-page.home-footer.footer-list.support-centre')}</Link>
                                        </li> */}
                      {/* <li><Link to="javascript:;">{t('home-page.home-footer.footer-list.downloads')}</Link>
                                        </li> */}
                      <li>
                        <Link to="/documentation">
                          {t("home-page.home-footer.footer-list.document")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/eids">
                          {t(
                            "home-page.home-footer.footer-list.supported-eids"
                          )}
                        </Link>
                      </li>
                      {/* <li>
                        <Link to="/customer-stories">
                          {t(
                            "home-page.home-footer.footer-list.customer-stories"
                          )}
                        </Link>
                      </li> */}
                    </ul>
                  </li>
                  <li className="col-md-3 col-sm-3 col-xs-6">
                    <ul className="list list-custom">
                      <li className="list-heading">
                        {t("home-page.home-footer.footer-list.solutions")}
                      </li>
                      <li>
                        <Link to="/solutions">
                          {t("home-page.home-footer.footer-list.overview")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions/signature-collection">
                          {t(
                            "home-page.home-footer.footer-list.signature-collection"
                          )}
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions/e-signing-api">
                          {t("home-page.home-footer.footer-list.signing")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions/e-identification-api">
                          {t(
                            "home-page.home-footer.footer-list.identification"
                          )}
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions/e-sealing-api">
                          {t("home-page.home-footer.footer-list.sealing")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions/agent">
                          {t("home-page.home-footer.footer-list.agent")}
                        </Link>
                      </li>
                      <li>
                        <div
                          style={{
                            display: "flex",
                            direction: "row",
                            gap: "4px",
                            alignItems: "center",
                          }}
                          className="app-links"
                        >
                          <a
                            href="https://apps.apple.com/vn/app/gopaperless/id6751082534"
                            target="_blank"
                            rel="noreferrer"
                            style={{ display: "inline-block" }}
                          >
                            <img
                              src={
                                localStorage.getItem("i18nextLng") === "en"
                                  ? app_store_en
                                  : app_store_vi
                              }
                              alt="App Store"
                              style={{ maxHeight: "40px" }}
                            />
                          </a>
                          <a
                            href="https://play.google.com/store/apps/details?id=vn.mobileid.gopaperless.client&pcampaignid=web_share"
                            target="_blank"
                            rel="noreferrer"
                            style={{ display: "inline-block" }}
                          >
                            <img
                              src={
                                localStorage.getItem("i18nextLng") === "en"
                                  ? google_play_en
                                  : google_play_vi
                              }
                              alt="Google Play"
                              style={{ maxHeight: "40px" }}
                            />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
